import styled from '@emotion/styled';
import { CircularProgress } from '@mui/material';

import { blueUltramarine500 } from '../../theme/videa-style-tokens';

export const PrivacyButtonContainer = styled.div`
  .privacy-button {
    font-weight: 500;
    color: ${blueUltramarine500};
    gap: 0.125em;
    flex-direction: row;
    justify-content: flex-start;
  }
`;

export const LoadingSpinner = styled(CircularProgress)`
  margin: 4em auto;
  display: block;

  &.infinite-load-spinner {
    bottom: 0;
  }
`;
